import AvatarUser from "../../../components/Avatars";
import { AVATAR_DEFAULT } from "../../../constants";
import { showTheRightName } from "../../../utils/functions";
import MoreItem from "../components/listTasks/MoreItem";

export const _format_tasks_definition_table = (tasks = []) => {
    return tasks
        ?.filter((el) => el?.error === false || !el?.error)
        .map((el, index) => {
            const document_required = [2, 3, 4].includes(
                parseInt(el?.document_action)
            );
            return {
                key: index,
                items: [
                    {
                        key: index + "_1",
                        content: showTheRightName({
                            document_required,
                            name: el?.name,
                            documents_template: el?.documents_template,
                        }),
                        truncateContent: true,
                    },
                    {
                        key: index + "_2",
                        content: el?.due_date,
                        truncateContent: true,
                    },
                    {
                        key: index + "_3",
                        content: (
                            <AvatarUser
                                key={`avatar_${index}`}
                                image={
                                    el?.assigned_to_user?.avatar ||
                                    el?.assigned_to?.image ||
                                    el?.assigned_to?.avatar ||
                                    AVATAR_DEFAULT
                                }
                                name={
                                    el?.assigned_to_user?.name ||
                                    el?.assigned_to?.name ||
                                    el?.assigned_to?.header
                                }
                                showName={true}
                            />
                        ),
                        truncateContent: true,
                    },
                    {
                        key: index + "_4",
                        content: (
                            <MoreItem key={`more points ${index}`} task={el} />
                        ),
                    },
                ],
            };
        });
};
